import { rem } from 'polished';
import styled from 'styled-components';

export const StyledContent = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    position: absolute;
    top: ${({ theme }) => rem(theme.spacings.xl)}; // TODO change this?
  }
`;

export const StyledImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
`;

export const StyledHeader = styled.header`
  position: absolute;
  top: ${rem('64px')};
  right: ${({ theme }) => rem(theme.spacings.s)};
  left: ${({ theme }) => rem(theme.spacings.s)};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.m}) {
    right: ${rem('32px')};
    left: ${rem('32px')};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    position: static;
    top: auto;
    right: auto;
    left: auto;
  }
`;

export const StyledWrapper = styled.section`
  position: relative;
`;
